<template>
  <div id="preloader">
    <div class="preloader">
      <div class="waviy">
        <span>N</span>
        <span>Y</span>
        <span>L</span>
        <span>O</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PreLoader",
});
</script>
